module.exports = __webpack_public_path__ + "img/dev_tools_opened_chrome.d3df07c5.png";